import React from 'react';

function NavBar({ 
    onShowAIAssistant,
    onShowDashboard,
    user, 
    quotes, 
    dropdownSearchTerm, 
    setDropdownSearchTerm, 
    isDropdownOpen, 
    setIsDropdownOpen, 
    loadQuote,
    handleLogout,
    onShowAdmin
}) {
    return (
        <>
            <nav className="navbar">
                <div className="navbar-container">
                    <div className="navbar-logo" onClick={onShowDashboard} style={{ cursor: 'pointer' }}>
                        <img src="/Logo-5.png" alt="Omntec Dark Logo" style={{ marginLeft: '10px' }}/>
                    </div>
                    
                    <div className="navbar-buttons">
                        <button className="nav-button" onClick={onShowDashboard}>
                            My Dashboard
                        </button>
                        
                        <div className="user-info-dropdown">
                            <button className="nav-button" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                                My Quotes
                            </button>
                            
                            <div className={`dropdown-content ${isDropdownOpen ? 'active' : ''}`}>
                                <h3>Your Quotes</h3>
                                <div className="search-container">
                                    <input
                                        type="text"
                                        placeholder="Search quotes..."
                                        value={dropdownSearchTerm}
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            setDropdownSearchTerm(e.target.value);
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        className="search-input"
                                    />
                                </div>
                                <div className="quotes-list">
                                    {quotes.length === 0 ? (
                                        <p>You have no previous quotes.</p>
                                    ) : (
                                        quotes
                                            .sort((a, b) => b.quote_number - a.quote_number)
                                            .filter(quote => {
                                                const details = JSON.parse(quote.quote_details);
                                                const company = details.facilityInfo?.company || 'Unknown Company';
                                                const name = details.facilityInfo?.name || '';
                                                const searchString = `${company} ${name}`.toLowerCase();
                                                return searchString.includes(dropdownSearchTerm.toLowerCase());
                                            })
                                            .slice(0, 20)
                                            .map((quote, index) => {
                                                const details = JSON.parse(quote.quote_details);
                                                const company = details.facilityInfo?.company || 'Unknown Company';
                                                return (
                                                    <div
                                                        key={index}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            loadQuote(quote);
                                                            setIsDropdownOpen(false);
                                                        }}
                                                        className="quote-item"
                                                    >
                                                        <p>{company} - #{quote.quote_number}</p>
                                                    </div>
                                                );
                                            })
                                    )}
                                </div>
                                
                            </div>
                        </div>
                        
{/*                         <button className="nav-button" onClick={onShowAIAssistant}>
                            Proteus AI Assistant
                        </button> */}
                        
                        <div className="navbar-end">
                        {user?.is_admin && (
                                <button style={{marginRight: '5px'}} className="nav-button" onClick={onShowAdmin}>
                                    Admin
                                </button>
                            )}
                            <button onClick={handleLogout} className="logout-button">
                                Logout
                            </button>
                            
                        </div>
                    </div>
                </div>
            </nav>
            {isDropdownOpen && <div className="dropdown-overlay" onClick={() => setIsDropdownOpen(false)} />}
        </>
    );
}

export default NavBar;